import React from 'react';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import MASpinner from '../../components/common/MASpinner';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import InvoiceUpdatedInsuranceDetailsListTable from './InvoiceUpdatedInsuranceDetailsListTable';
import { isChaserOutsourcer, isStaff } from '../../lib/helper/authorisation';
import { addToast } from '../../lib/redux/actions/toast';
import { getFiltersFromSession } from '../../lib/routing/filters';
import AppliedFiltersOutput from '../../components/common/AppliedFiltersOutput';
import {
  insuranceDetailUpdateListClearFilters,
  insuranceDetailUpdateListFetch,
  insuranceDetailUpdateListSetPage,
  insuranceDetailUpdateListUnload,
} from '../../lib/redux/actions/insuranceDetails';
import InsuranceDetailsUpdateTableFilterForm from '../../components/forms/InsuranceDetails/InsuranceDetailsUpdateTableFilterForm';

const mapStateToProps = (state) => ({
  ...state.insuranceDetails,
  ...state.stats,
});

const mapDispatchToProps = {
  insuranceDetailUpdateListFetch,
  insuranceDetailUpdateListSetPage,
  insuranceDetailUpdateListUnload,
  insuranceDetailUpdateListClearFilters,
  addToast,
};

class InvoiceUpdatedInsuranceDetailsListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {}, match } = this.props;
    let filtersFromSession = getFiltersFromSession(match.path, 'json');
    let returnFilters = { ...defaultFilters, ...filters, ...filtersFromSession };
    //    if (filtersFromSession && filtersFromSession['outstandingBalance(gte)'] !== "undefined") {
    //      returnFilters['outstandingBalance(gte)'] = filtersFromSession['outstandingBalance(gte)'];
    //    }
    //    if (filtersFromSession && filtersFromSession['outstandingBalance(lte)'] !== "undefined") {
    //      returnFilters['outstandingBalance(lte)'] = filtersFromSession['outstandingBalance(lte)'];
    //    }
    //
    //    if (returnFilters['assignedTo']) {
    //      delete returnFilters['exists(assignedTo)'];
    //    }
    //
    //    if (returnFilters['payorType']) {
    //      delete returnFilters['payorType.code'];
    //    }
    return returnFilters;
  }

  //  componentWillUnmount() {
  //    let persistFilters = this.props.match.path.includes('/insurance-details-updated/:page');
  //    this.props.insuranceDetailUpdateListFetch(persistFilters);
  //  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.props.insuranceDetailUpdateListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const {
      currentPage,
      insuranceDetailUpdateListFetch,
      insuranceDetailUpdateListSetPage,
      insuranceDetailUpdateListUnload,
      insuranceDetailUpdateListClearFilters,
      defaultFilters,
      filters,
    } = this.props;
    let persistFilters = this.props.match.path.includes('/insurance-details-updated/:page');
    if (prevProps.defaultFilters !== defaultFilters) {
      insuranceDetailUpdateListUnload(persistFilters);
      if (!persistFilters) {
        insuranceDetailUpdateListClearFilters();
      }
      this.loadData();
      this.setState(() => {
        return { showFilters: false };
      });
    }

    if (prevProps.match.params.page !== this.props.match.params.page) {
      insuranceDetailUpdateListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      insuranceDetailUpdateListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return Number(this.props.match.params.page) || 1;
  }

  changePage(page) {
    const { history, insuranceDetailUpdateListSetPage, path } = this.props;
    insuranceDetailUpdateListSetPage(page);
    history.push(path.replace(':page', page));
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  toggleFilters() {
    this.setState((prevState) => {
      return { showFilters: !prevState.showFilters };
    });
  }

  render() {
    const {
      insuranceDetailUpdates,
      stats,
      isFetchingInvoices,
      pageTitle,
      pageType,
      pageCount,
      currentPage,
      defaultFilters = {},
      filterOverrides = {},
    } = this.props;
    let invoicesLeftClass = 'badge badge-pill badge-danger mr-3';
    return (
      <Card>
        <Card.Header>
          <div className="d-flex justify-content-between">
            {' '}
            {pageTitle}
            <div>
              {pageType === 'bulk' && stats.creditControlInvoicesUnassigned && stats.creditControlInvoicesUnassigned > 0 ? (
                <span className={invoicesLeftClass} title="Invoices to assign">
                  {stats.creditControlInvoicesUnassigned}
                </span>
              ) : null}
              {pageType === 'all' && (isChaserOutsourcer(true) || isStaff(true)) && stats.invoicesCurrentlyAssigned && stats.invoicesCurrentlyAssigned > 0 ? (
                <span className={invoicesLeftClass} title="Invoices to process">
                  {stats.invoicesCurrentlyAssigned}
                </span>
              ) : null}
              <button className="btn btn-sm btn-outline-secondary mr-3" onClick={this.toggleFilters.bind(this)}>
                Filters
              </button>
              <span className="tabular-data-result-count">{pageCount} pages</span>
              {isFetchingInvoices && <MASpinner wrapperClasses="ml-3 float-right" size="sm" />}
            </div>
            {/*}*/}
          </div>
        </Card.Header>

        {this.state.showFilters && (
          <Card.Body className={'mediaccount-filter-wrapper'}>
            <InsuranceDetailsUpdateTableFilterForm
              defaultFilters={defaultFilters}
              filterOverrides={filterOverrides}
              setPage={this.changePage.bind(this)}
              pageType={pageType}
              location={this.props.match.path}
            />
          </Card.Body>
        )}

        {(insuranceDetailUpdates === null || insuranceDetailUpdates.length === 0) && (
          <Card.Body>
            <Alert variant={'info'} className="mb-0">
              No Invoices found
            </Alert>
          </Card.Body>
        )}

        <AppliedFiltersOutput />

        {insuranceDetailUpdates && insuranceDetailUpdates.length > 0 && (
          <InvoiceUpdatedInsuranceDetailsListTable insuranceDetailUpdates={insuranceDetailUpdates} pageType={pageType} reload={this.loadData.bind(this)} />
        )}
        {insuranceDetailUpdates && insuranceDetailUpdates.length > 0 && (
          <Paginator
            currentPage={currentPage}
            pageCount={pageCount}
            setPage={this.changePage.bind(this)}
            nextPage={this.nextPage.bind(this)}
            prevPage={this.prevPage.bind(this)}
          />
        )}
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceUpdatedInsuranceDetailsListContainer);
